export const limitModalSymbol = Symbol('limitModal');
export const buyCreditSymbol = Symbol('buyCredit');
export const buyStorageSymbol = Symbol('buyStorage');
